import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { UserService } from "../services/user/user.service";
import { B2cService } from "../services/b2c/b2c.service";
import { CartService } from "../services/cart/cart.service";
import {Router} from "@angular/router"
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {
  isproduct:any;
  profile = {name:"",ref:"",email:"",tel:"",adresse:"",adresseSuit:"",ville:"",ice:"",raisonSociale:""};
  isConfirm  = false;
  errorRC    = false;
  errorPhone = false;
  errorEmail = false;
  errorRequired = false
  sendOrder = false
  typeCompte:any;
  constructor(private userService:UserService,private cartService:CartService,private b2cService:B2cService,private router:Router) {
    let user = localStorage.getItem('user')
    if(!user) this.router.navigate(['/connexion'])
  }

  ngOnInit(): void {
    this.typeCompte = localStorage.getItem('typeCompte');


    if (localStorage.getItem('typeCompte')=="B2B") {
        this.userService.getProfile().subscribe(res=>{
        this.profile.email = res["profile"].WEB;
        this.profile.tel = res["profile"].TEL;
        this.profile.adresse = res["profile"].BPAADDLIG0;
        this.profile.ville = res["profile"].CTY;
        this.profile.ice = res["profile"].XICE;
        this.profile.raisonSociale = res["profile"].BPRNUM;
        this.profile.ref = res["profile"].BPRNUM;

      })
    }else if(localStorage.getItem('typeCompte')=="B2C"){
      let user = JSON.parse(localStorage.getItem('user'))
      this.profile.email = user.email;
      this.profile.adresse = user.address;
      this.profile.tel = "";
      this.profile.ville = "";
      this.profile.ref = "";
    }
  }

  confirm(){
    if(this.check()){
      this.errorRequired = false
      this.sendOrder = true;
      if (localStorage.getItem('typeCompte')=="B2B") {
        let data = {
          "name": this.profile.ice,
          "address": this.profile.adresse,
          "address2": this.profile.adresseSuit,
          "email": this.profile.email
        }
        this.cartService.confirmeCart(data).subscribe(res=>{
          this.isConfirm = true;
          this.cartService.panierCount=0
          localStorage.removeItem('card');
          setTimeout(() => {
              this.router.navigate(['/commandes'])
          }, 1500);
          this.clearCart()
        })
      }else if(localStorage.getItem('typeCompte')=="B2C")
      {
        let user = JSON.parse(localStorage.getItem('user'))
        let cart = JSON.parse(localStorage.getItem('card'))

        let cartStructer = [];
        let nbrProduct = 0;
        let montant_ht = 0;
        let montant_ttc = 0;
        var cartJson = [];
        cart.forEach(item => {
          cartStructer.push({
              ITMREF : item.product.ITMREF,
              QTY: item.item_quantity
          })

          cartJson.push({"ITMREF":item.product.ITMREF,"ITMDES":item.product.ITMDES1,"QTY":item.item_quantity,"SOQSTA_LBL":"","NETPRI":item.product.PRIXNET})
          montant_ht += parseInt(item.product.PRIXBRUT)
          montant_ttc += parseInt(item.product.PRIXNET)
          nbrProduct++;
        });

        let data = {
          "name": user.firstname+" "+user.lastname,
          "address": user.address,
          "address2": user.address2,
          "email": user.email,
          "cart": cartStructer
        }


        this.b2cService.confirmeCart(data).subscribe((res:any)=>{
          this.isConfirm = true;
          localStorage.removeItem('card');
          this.cartService.panierCount=0


          var commandForm = new FormData();
          commandForm.append('userId', user.id );
          commandForm.append('ref', res.numOrder );
          commandForm.append('montant_ht', montant_ht.toString());
          commandForm.append('montant_ttc', montant_ttc.toString());
          commandForm.append('nbr',nbrProduct.toString());
          commandForm.append('cart',JSON.stringify(cartJson));
          this.b2cService.addCommand(commandForm).subscribe(res=>{
            setTimeout(() => {
                this.router.navigate(['/moncompte'])
            }, 2500);
          })


        })
      }
    }else{
      this.errorRequired = true
    }


  }


  clearCart()
  {
    this.cartService.getCart().subscribe(res=>{
      res['cart'].forEach(elementCart => {
        this.cartService.removeFromCart(elementCart.ITMREF).subscribe(res=>{})
      });
    })
  }
  check(){
    if(this.profile.ref != "" && this.profile.email!="" && this.profile.tel!="" && this.profile.adresse!="" && this.profile.ville!="" && this.errorRC == false && this.errorEmail == false && this.errorPhone == false){
      if(this.profile.ice!="" && localStorage.getItem('typeCompte')=='B2B'){
        return true;
      }else if(this.profile.name !=""){
        return true;
      }else{
        return false;
      }
      
    }else{
      return false
    }
  }
  checkRc(){
    if(localStorage.getItem('typeCompte')=='B2B'){
      if((this.profile.ice.length!=15 && this.profile.ice != '')){
        this.errorRC = true;
        return false;
      }else{
        this.errorRC = false;
        return true;
      }
    }
    return true;
  }

  checkEmail(){
    if(this.profile.email != ''){
      var re = /\S+@\S+\.\S+/;
      this.errorEmail = !re.test(this.profile.email);
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  checkPhone(){
    if((this.profile.tel.length!=10 && this.profile.tel != '')){
      this.errorPhone = true;
      return false;
    }else{
      this.errorPhone = false;
      return true;
    }
  }

}
